import { render } from "./MissingDefectLabel.vue?vue&type=template&id=50311104&scoped=true"
import script from "./MissingDefectLabel.vue?vue&type=script&lang=js"
export * from "./MissingDefectLabel.vue?vue&type=script&lang=js"

import "./MissingDefectLabel.vue?vue&type=style&index=0&id=50311104&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50311104"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBar from 'quasar/src/components/bar/QBar.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTooltip,QDialog,QCard,QBar,QSpace,QCardSection,QInput,QTable});
